var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { DefaultToastContainer } from 'react-toast-notifications';
import { mq, styled } from "../utils";
var ToastContainer = styled(DefaultToastContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 10000000;\n\n  ", ";\n"], ["\n  z-index: 10000000;\n\n  ",
    ";\n"])), mq({
    padding: [0, '2rem 1rem 0 0', '3rem, 1rem 0 0'],
    width: ['100%', '421px'],
}));
export default ToastContainer;
var templateObject_1;
//# sourceMappingURL=ToastContainer.js.map